import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminAutoReplies = lazy(() => import("@/pages/admin/AdminAutoReplies"));

export const Route = createFileRoute("/admin/arenden/automatiska-svar")({
  head: () => ({ meta: [{ title: "Automatiska svar – Adminpanel" }] }),
  component: AdminAutoReplies,
});
